export const OCCUPANCIES_ROUTE_PATH = '/occupancy';
export const OCCUPANCY_ROUTE_PATH = '/occupancy/:id';

export const PROPERTY_OCCUPANCY_ROUTE_PATH = '/occupancy/:propertyId';
